module.exports = __webpack_public_path__ + "static/shang-yu_resume_20260107.e15a0461.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/shang-yu_resume_20260107.pdf
// module id = 342
// module chunks = 213534597649335